module.exports = __webpack_public_path__ + "static/orwell-43485758dc5b1ba05c55ef5c684cf623.png";